import ApiService from "@/Services/ApiService";
// import { TextField, Box } from "@mui/material";
import axios from "axios";
import Image from "next/image";
import React, { useState } from "react";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Icons from "../../../public/icons/contactIcons";
import Link from "next/link";
import Header from "@/component/Header/NewHeader";
import {
  TextField,
} from "@mui/material";
import SelectItem from 'react-select';

const options = [
  { value: 'Background Check Software', label: 'Background Check Software' },
  { value: 'Background Check APIs', label: 'Background Check APIs' },
  // { value: 'Video KYC', label: 'Video KYC' },
  { value: 'Due Diligence Software', label: 'Due Diligence Software' },
  { value: 'Digital Address Verification', label: 'Digital Address Verification' },
  { value: 'Field Executive tracking', label: 'Field Executive tracking' },
  { value: 'Vendor Management', label: 'Vendor Management' },
  { value: 'Staff Management', label: 'Staff Management' },
  { value: 'Other', label: 'Other' },
];
export default function RequestDemo({ additionalPhone }) {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [company, setCompany] = useState("")
  const [error, setError] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);


  const validation = () => {
    let errors = {};
    let formIsValid = true;

    if (!firstName) {
      formIsValid = false;
      errors["fullName"] = "*Please enter your full name";
    }
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!email || regex.test(email) === false) {
      formIsValid = false;
      errors["email"] = "*Please enter your email";
    }
    if (!message) {
      formIsValid = false;
      errors["message"] = "*Please enter message";
    }
    if (!company) {
      formIsValid = false;
      errors["company"] = "*Please enter Company Name";
    }
    const phregex = /^[+]?\d{10}$/;
    if (!phoneNo || phregex.test(phoneNo) === false) {
      formIsValid = false;
      errors["number"] = "*Please enter a valid phone number";
    }
    setError(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target || e;
    if (name === "fullName") {
      setFirstName(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "company") {
      setCompany(value);
    } else if (name === "message") {
      setMessage(value);
    } else if (name === "phoneNo") {
      setPhoneNo(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validation()) {
      const data = {
        fullName: firstName,
        email: email,
        phoneNumber: phoneNo,
        message: message,
        company: company,
        isDemoRequested: true,
      };

      axios
        .post("/api/request-demo", data)
        .then(() => {
          ApiService.post("api/request-demos", { data });
          setFirstName("");
          setEmail("");
          setMessage("");
          setCompany("")
          setPhoneNo("");
          toast.success("Your message has been sent. We’ll be in touch soon.");
        })
        .catch((error) => {
          console.log(error);
          toast.error("Something is wrong!");
        });
    }
    else {
      toast.error("Please fill details");
    }
  };

  return (
    <>
      <div className=" lg:my-14 max-md:mb-5 max-sm:min-h-screen">
        <div className="flex flex-col lg:flex-row gap-4 md:mt-4">
          <div className="flex flex-col max-sm:px-[10px] max-md:px-[20px]">
            {/* <p className='text-blue-600 font-bold text-lg mt-2'>Talk to sales</p> */}
            <div className="max-md:hidden flex md:flex-row mt-4  gap-4">
              {additionalPhone ? (
                <div className="flex items-center">
                  <Icons name="phone-number" />
                  <span className="pl-2 text-[#168DEF] g-sm">{additionalPhone}</span>
                </div>
              ) : null}
              <div className="flex items-center">
                <Icons name="phone-number" />
                <span className="pl-2 text-[#168DEF] g-sm">+91 786 969 6156</span>
              </div>
            </div>
            <p className="text-[#3A3D46] text-[43px] max-sm:text-[25px] g-sm sm:leading-[3rem] leading-[2rem] mt-3">  Ready to Explore CoinCircleTrust for your business?</p>
            <div className="md:hidden sm:flex grid flex-row mb-3 sm:gap-4 gap-3">
              {additionalPhone ? (
                <div className="flex items-center">
                  <Icons name="phone-number" />
                  <span className="pl-2 text-[#168DEF] g-sm">{additionalPhone}</span>
                </div>
              ) : null}
              <div className="flex items-center">
                <Icons name="phone-number" />
                <span className="pl-2 text-[#168DEF] g-sm">+91 786 969 6156</span>
              </div>
            </div>
            <p className='mb-8 g-m text-[17px] max-sm:text-[15px] max-sm:leading-6 text-[#3A3D46]'> We’d love to show you how coincircletrust can help your business. Fill out the form and we’ll be in touch within 24 hours.</p>

            <p className="flex gap-2 g-m text-[17px] text-[#3A3D46]"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none"><rect x="0.817871" y="0.0322266" width="28" height="28" rx="14" fill="#D1E9FF"></rect><path fillRule="evenodd" clipRule="evenodd" d="M20.7635 8.65416L12.4102 16.7158L10.1935 14.3475C9.78521 13.9625 9.14355 13.9392 8.67688 14.2658C8.22188 14.6042 8.09355 15.1992 8.37355 15.6775L10.9985 19.9475C11.2552 20.3442 11.6985 20.5892 12.2002 20.5892C12.6785 20.5892 13.1335 20.3442 13.3902 19.9475C13.8102 19.3992 21.8252 9.84416 21.8252 9.84416C22.8752 8.77083 21.6035 7.82583 20.7635 8.64249V8.65416Z" fill="#2E90FA"></path></svg>Assess your team’s needs</p>
            <p className="flex gap-2 g-m text-[17px] text-[#3A3D46]">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none"><rect x="0.817871" y="0.0322266" width="28" height="28" rx="14" fill="#D1E9FF"></rect><path fillRule="evenodd" clipRule="evenodd" d="M20.7635 8.65416L12.4102 16.7158L10.1935 14.3475C9.78521 13.9625 9.14355 13.9392 8.67688 14.2658C8.22188 14.6042 8.09355 15.1992 8.37355 15.6775L10.9985 19.9475C11.2552 20.3442 11.6985 20.5892 12.2002 20.5892C12.6785 20.5892 13.1335 20.3442 13.3902 19.9475C13.8102 19.3992 21.8252 9.84416 21.8252 9.84416C22.8752 8.77083 21.6035 7.82583 20.7635 8.64249V8.65416Z" fill="#2E90FA"></path></svg></span>Learn more about CoinCircleTrust's Product & Benefits</p>
            <p className="flex gap-2 g-m text-[17px] text-[#3A3D46]"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none"><rect x="0.817871" y="0.0322266" width="28" height="28" rx="14" fill="#D1E9FF"></rect><path fillRule="evenodd" clipRule="evenodd" d="M20.7635 8.65416L12.4102 16.7158L10.1935 14.3475C9.78521 13.9625 9.14355 13.9392 8.67688 14.2658C8.22188 14.6042 8.09355 15.1992 8.37355 15.6775L10.9985 19.9475C11.2552 20.3442 11.6985 20.5892 12.2002 20.5892C12.6785 20.5892 13.1335 20.3442 13.3902 19.9475C13.8102 19.3992 21.8252 9.84416 21.8252 9.84416C22.8752 8.77083 21.6035 7.82583 20.7635 8.64249V8.65416Z" fill="#2E90FA"></path></svg>Discuss pricing options</p>
          </div>
          <div className="xl:w-[80%] bg-blue-50 border-blue-100 border-2 rounded-md p-4">
            <h2 className='py-4 g-sm'>Hi!👋 Let's schedule your Demo</h2>
            <div className="grid grid-cols-1 gap-4 mb-6">
              <TextField
                id="fullName"
                label="Full Name"
                variant="outlined"
                name="fullName"
                value={firstName}
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
                }}
                onChange={handleChange}
                error={Boolean(error["fullName"])}
                helperText={error["fullName"]}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <TextField
                id="email"
                label="Email"
                variant="outlined"
                name="email"
                value={email}
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
                }}
                onChange={handleChange}
                error={Boolean(error["email"])}
                helperText={error["email"]}
              />
              <TextField
                id="company"
                label="Company Name"
                variant="outlined"
                name="company"
                value={company}
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
                }}
                onChange={handleChange}
                error={Boolean(error["company"])}
                helperText={error["company"]}
              />
            </div>
            <div className="grid grid-cols-1 gap-4 my-6">
              <TextField
                id="phoneNo"
                label="Phone Number"
                variant="outlined"
                name="phoneNo"
                value={phoneNo}
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
                }}
                onChange={handleChange}
                error={Boolean(error["number"])}
                helperText={error["number"]}
              />
              {/* {error["number"] && (
              <span style={{ color: "red" }}>{error["number"]}</span>
            )} */}
            </div>
            <SelectItem
              instanceId="custom-select"
              defaultValue={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.value); if (e.value !== "Other") {
                  setMessage(e.value);
                }
                else {
                  setMessage("");
                }
              }}
              placeholder="What are you looking for?"
              options={options}
              className="bg-blue-50 z-10"
              styles={{
                placeholder: (provided) => ({
                  ...provided,
                  color: '#5f6266',
                  fontSize: '16px',
                  height:'50px',
                  display:'flex',
                  alignItems:'center'
                }),
              }}
            />
            {selectedOption === "Other" ?
              <div className="grid grid-cols-1 gap-4 my-6">
                <TextField
                  id="message"
                  label="Please Provide Details"
                  variant="outlined"
                  name="message"
                  value={message}
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
                  }}
                  onChange={handleChange}
                  error={Boolean(error["message"])}
                  helperText={error["message"]}
                />
              </div> : ""}
            {/* <div className="grid grid-cols-1 gap-4 my-6">
            <TextField
              id="message"
              label="Message"
              name="message"
              variant="outlined"
              type="text"
              value={message}
              minRows={4}
              multiline
              style={{
                borderRadius: "8px",
                boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
              }}
              onChange={handleChange}
              error={Boolean(error["message"])}
              helperText={error["message"]}
            />
          </div> */}
            <p className='mt-1 g-m text-[17px]'> By submitting this form you are agreeing to our <Link href="/privacy-policy" className="!text-[#168DEF]">privacy policy</Link>.</p>
            <button
              type="submit"
              className="w-full px-10 py-3.5 text-base g-sm bg-[#168DEF] text-white text-center transition duration-500 ease-in-out transform rounded-xl"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
